import React from "react";
import Dashboard from "../pages/Dashboard";

export default function MobileDashboard() {
  return <div className="p-4"><Dashboard mobile /></div>;
}
